import { Button, Label, Textarea } from "@xola/ui-kit";
import { isArray } from "lodash";
import qz from "qz-tray";
import React, { useState } from "react";
import { Secrets } from "types";
import { queryClient } from "../../../api/queryClient";
import { getDefaultPrinter } from "../../../storages/PrinterStorage";
import { setCertificates } from "../../../utils/qzTray";

export const DebugReceiptPrinting = () => {
    const [debugPrintPayload, setDebugPrintPayload] = useState<string>("");
    /**
     * Data should be in array format
     * eg: [[{ "type": "pixel", "format": "html", "flavor": "plain", "data": "<div>ABC</div>" }], [{"type":"raw", "flavor":"hex", "data": "x1Bx64"}]]
     */
    const handleTestPrint = async () => {
        let printPayload: any[];

        try {
            printPayload = JSON.parse(debugPrintPayload);
        } catch {
            console.log("Error in parsing Data");
            return;
        }

        console.log("parsed data", printPayload);
        if (!isArray(printPayload)) {
            console.log("Invalid Test Data. Data should be an array of print commands");
            return;
        }

        const defaultPrinter = getDefaultPrinter();
        const { secrets } = queryClient.getQueryData<{ secrets: Secrets }>(["account"])!;

        await setCertificates(secrets).catch((error: any) => {
            console.error("Setting certificates failed", error);
        });

        await qz.websocket.connect().catch((error: any) => {
            console.error("Connect failed", error);
        });

        // eslint-disable-next-line unicorn/no-array-callback-reference
        const printer = await qz.printers.find(defaultPrinter).catch((error: any) => {
            console.error("Finding printer failed", error);
        });

        console.log("Test printing payload using", printer);

        if (printer) {
            const config = qz.configs.create(printer);

            // logic from https://qz.io/docs/raw-legacy#promise-loop
            const promises = [];
            for (let index = 0; index < printPayload.length; index++) {
                (function (index_) {
                    const link = function () {
                        return qz.print(config, printPayload[index_]);
                    };

                    promises.push(link);
                })(index);
            }

            const firstLink = new Promise(function (r: any) {
                r();
            });
            let lastLink: any = null;

            // eslint-disable-next-line unicorn/no-array-reduce
            promises.reduce(function (sequence, link) {
                console.log("Printing item");
                lastLink = sequence.then(link);
                return lastLink;
            }, firstLink);

            // this will be the very last link in the chain
            lastLink
                .then(async () => {
                    console.log("Printing Done for all items");
                    disconnectQZConnection();
                })
                .catch((error: any) => {
                    console.log("Error in printing item", error);
                    disconnectQZConnection();
                });
        }
    };

    return (
        <div className="!mt-10 space-y-2">
            <Label>Test Receipt Printing</Label>
            <Textarea value={debugPrintPayload} onChange={(e: any) => setDebugPrintPayload(e.target.value)} />
            <Button color="secondary" variant="outline" onClick={handleTestPrint}>
                Print
            </Button>
        </div>
    );
};

const disconnectQZConnection = async () => {
    await qz.websocket
        .disconnect()
        .then(() => {
            console.log("Disconnected QZ websocket");
        })
        .catch((error: any) => {
            console.error("Disconnect failed", error);
        });
};
